/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBookReader} from '@fortawesome/pro-duotone-svg-icons';

const ProfessionalLearningIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faBookReader} {...props} />
);

export default ProfessionalLearningIcon;
